import { Observable, of } from 'rxjs';
import { IAssignRevokePermissionsRequest } from '../dtos/requests/assign-revoke-permissions.request';
import { IAssignRevokePermissionsClient } from './i-assign-revoke-permissions.client';
import { assignedPermissionsTestData, permissionGroupsTestData } from '../data/permission-groups.data';
import { IPermissionGroup } from '../models/permission-group.model';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AssignRevokePermissionsInMemoryClient implements IAssignRevokePermissionsClient {
  permissionGroups(): Observable<IPermissionGroup[]> {
    return of(permissionGroupsTestData);
  }

  assignedPermissionGroups(endpoint: string): Observable<IPermissionGroup[]> {
    return of(assignedPermissionsTestData);
  }

  assign(endpoint: string, body: IAssignRevokePermissionsRequest): Observable<void> {
    return of();
  }

  revoke(endpoint: string, body: IAssignRevokePermissionsRequest): Observable<void> {
    return of();
  }
}
